<template>
  <div class="join-condition">
    <!-- <img src="//static.geekbang.org/infoq/5b75671c4a21a.png" alt="" v-if="isMobile">
    <img src="//static.geekbang.org/infoq/5b7567542f247.png" alt="" v-if="!isMobile"> -->
    <div class="container">
      <ego-title :title="title" :subtitle="''" class="condition-title"></ego-title>
      <div class="step">
        <div class="item">
          <img src="./assets/icon-1.png" alt="">
          <h3>推&nbsp;&nbsp;&nbsp;荐</h3>
          <p>每位申请人需要被至少一位TGO 学员或者 CTO、技术高管、或一家技术媒体推荐</p>
        </div>
        <div class="item">
          <img src="./assets/icon-2.png" alt="">
          <h3>资&nbsp;&nbsp;&nbsp;格</h3>
          <p>申请人需具备至少 5 年技术工作经验、两年以上的管理经验、带领过 30 人以上技术/产品/运营团队</p>
        </div>
        <div class="item">
          <img src="./assets/icon-3.png" alt="">
          <h3>审&nbsp;&nbsp;&nbsp;核</h3>
          <p>通过提交资料初审及严格的面试筛选，综合考察个人资质，最终确认是否符合加入标准</p>
        </div>
        <div class="item">
          <img src="./assets/icon-4.png" alt="">
          <h3>学&nbsp;&nbsp;&nbsp;费</h3>
          <p>新学员加入 TGO 鲲鹏会学费标准：10080元/年。说明：TGO 鲲鹏会财政年度起止日期为当年 7 月 1 日至次年 6 月 30 日，所有新缴费加入和续费学员，均须交纳至次年 6 月 30 日</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import egoTitle from '@/base/ego-title'
export default {
  data () {
    return {}
  },
  props: ['isMobile'],
  components: {
    egoTitle
  },
  computed: {
    title () {
      return '申请条件'
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../../style/bulma/app.sass'

.join-condition
  width: 100vw
  // height: 43vw
  margin: 0 auto
  +mobile
    height: auto
  +desktop
    width: 100vw
    // height: 40vw
    background: url('./assets/bak.jpg') bottom left no-repeat
    background-size: cover
    padding-bottom: 75px
  img
    vertical-align: middle
  .container
    display: flex
    flex-direction: column
    align-items: center
    padding-top: 90px
    +mobile
      padding-top: 34px
      width: 100vw
    .condition-title
      margin-bottom: 50px
      +mobile
        margin-bottom: 10px
    .step
      display: flex
      justify-content: center
      text-align: center
      +mobile
        flex-wrap: wrap
      .item
        width: 25%
        padding: 0 30px
        border-right: 1px solid #e8e8e8
        +mobile
          width: 50%
          padding: 6vw !important
          border: 0
          border-top: 1px solid #ebebeb
          &:nth-child(2n-1)
            border-right: 1px solid #ebebeb
        img
          width: 70px
          height: 70px
          display: block
          margin: 0 auto 25px
          +mobile
            width: 51px
            height: 51px
            margin-bottom: 4px
        h3
          font-size: 30px
          font-weight: bold
          margin-bottom: 25px
          +mobile
            font-size: 20px
            margin-bottom: 0
        p
          font-size: 16px
          +mobile
            font-size: 10px
      .item:last-child
        border-right: none
        padding-right: 0
      .item:first-child
        padding-left: 0
</style>
